import React from 'react';
import { ROUNDS } from './data';

const TAG = {
  'Non-elimination': 'bg-[#D7FF38] text-[#111]',
  Elimination: 'bg-[#FF6338] text-[#111]',
  Final: 'bg-[#111] text-[#D7FF38] border-[#D7FF38]',
};

export const ConvergeRounds = () => (
  <section className="scroll-mt-20 bg-[#111] text-[#F5F3EB] border-b-2 border-[#111]" data-testid="rounds-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#D7FF38]">[ 04 ] Format</p>
      <h2 className="cv-display font-extrabold uppercase leading-[0.9] mt-3 text-4xl sm:text-6xl lg:text-7xl" data-testid="rounds-title">24 hours.<br />Three rounds.<br /><span className="text-[#D7FF38]">One big idea.</span></h2>
      <p className="mt-6 inline-block border-2 border-[#F5F3EB] px-3 py-2 text-xs sm:text-sm font-bold uppercase tracking-wider" data-testid="rounds-window">
        Hackathon runs 1:00 PM, 16 November → 1:00 PM, 17 November 2026
      </p>
      <ol className="mt-12 grid lg:grid-cols-3 gap-6 lg:gap-0">
        {ROUNDS.map((r, i) => (
          <li key={r.n} className={`relative border-2 border-[#F5F3EB] p-6 sm:p-8 ${i > 0 ? 'lg:border-l-0' : ''}`} data-testid={`round-${r.n}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className="cv-display text-6xl font-extrabold text-[#365CFF]">{r.n}</span>
              <span className={`border-2 border-[#111] px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wider ${TAG[r.tag]}`} data-testid={`round-${r.n}-tag`}>{r.tag === 'Final' ? 'Final round' : r.tag}</span>
            </div>
            <p className="mt-6 text-[11px] font-bold uppercase tracking-[0.2em] text-[#D7FF38]">Round {r.n}</p>
            <h3 className="cv-display text-xl xl:text-2xl font-extrabold uppercase leading-tight mt-1 break-words">{r.title}</h3>
            <p className="mt-3 text-xs font-bold">{r.when}</p>
            <p className="mt-4 text-sm text-[#F5F3EB]/80">{r.text}</p>
            {i < ROUNDS.length - 1 && <span className="hidden lg:flex absolute top-1/2 -right-5 z-10 w-10 h-10 bg-[#D7FF38] text-[#111] border-2 border-[#111] items-center justify-center font-extrabold" aria-hidden="true">→</span>}
          </li>
        ))}
      </ol>
    </div>
  </section>
);
